import React from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { CustomFieldSchemaFragment } from "__generated__/graphql";
import { parseISO } from "date-fns";
import { toLocalISOdateString } from "helpers/dateUtils/toLocalISOdateString";

interface ICustomDateFieldProps {
  value: string;
  setValue: (value: string) => void;
  schema?: CustomFieldSchemaFragment;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  touched?: boolean;
}
export const CustomDateField = ({
  value,
  setValue,
  schema,
  showLabel,
  labelledById,
  onKeyDown,
  errorMessage,
  touched,
}: ICustomDateFieldProps) => {
  const parsedDate = (value ? parseISO(value) : null) as Date | string | null;
  const defaultValue = parsedDate instanceof Date ? parsedDate : null;

  return (
    <DesktopDatePicker
      defaultValue={defaultValue}
      onChange={(e) => {
        const e_with_correct_type = e as Date | string | null;
        if (e_with_correct_type instanceof Date) {
          setValue(toLocalISOdateString(e_with_correct_type));
        } else {
          setValue("");
        }
      }}
      slotProps={{
        textField: {
          "aria-labelledby": labelledById,
          variant: "outlined",
          size: "small",
          fullWidth: true,
          error: touched && errorMessage ? true : false,
          helperText: errorMessage,
          label: showLabel && schema?.name,
          placeholder: schema?.name,
          InputLabelProps: {
            shrink: true,
          },
          onKeyDown,
        },
      }}
    />
  );
};
